import { array, boolean, string, struct } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

import { Id as AncillaryItemId } from '../../../../../job/ancillary-item/Id';
import { Id as JobTypeId } from '../../../../../job/job-type/Id';
import { Id as RequestTypeId } from '../../../../../job/request-type/Id';
import { Id as RequirementId } from '../../../../../job/requirement/Id';
import { Id as SubAncillaryItemId } from '../../../../../job/sub-ancillary-item/Id';

export const Request = struct({
	capabilities: struct({
		jobTypes: array(JobTypeId),
		requestTypes: array(RequestTypeId),
		requirements: array(RequirementId),
		ancillaryItems: array(AncillaryItemId),
		subAncillaryItems: array(SubAncillaryItemId),
	}),

	defaults: struct({
		requirements: iotsUtils.makePartialRecordDecoder(
			constants.job.requirement.ids,
			array(AncillaryItemId)
		),
		ancillaryItems: iotsUtils.makePartialRecordDecoder(
			constants.job.ancillaryItem.ids,
			array(SubAncillaryItemId)
		),
	}),

	localisation: struct({
		jobType: struct({
			title: string,
			ids: iotsUtils.makePartialRecordDecoder(constants.job.jobType.ids, string),
		}),
		requestType: struct({
			title: string,
			ids: iotsUtils.makePartialRecordDecoder(constants.job.requestType.ids, string),
		}),

		jobName: string,
		jobRef: string,
		project: string,
		builder: string,
		customer: string,
		dueAt: string,
		salesPerson: string,
		customerContact: string,

		requirements: iotsUtils.makePartialRecordDecoder(constants.job.requirement.ids, string),
		ancillaryItems: iotsUtils.makePartialRecordDecoder(constants.job.ancillaryItem.ids, string),
		subAncillaryItems: iotsUtils.makePartialRecordDecoder(
			constants.job.subAncillaryItem.ids,
			string
		),
	}),

	features: struct({
		jobRef: struct({ enabled: boolean, required: boolean }),
		project: struct({ enabled: boolean, required: boolean }),
		builder: struct({ enabled: boolean, required: boolean }),
		customer: struct({ enabled: boolean, required: boolean }),
		dueAt: struct({ enabled: boolean, required: boolean }),
		salesPerson: struct({ enabled: boolean, required: boolean }),
		customerContact: struct({ enabled: boolean, required: boolean }),
	}),
});
